/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import Axios from "axios";
// import generateUsername from "generate-username-from-email";
// import swal from "sweetalert";
import "./index.css";
import { useParams, useLocation } from "react-router-dom";
import Button from "@material-ui/core/Button";
import TextEditor from "./TextEditor";
import EmailContact from "./EmailContact";
import { toast } from "helpers/apiRequests";
import { CircularProgress } from "@material-ui/core";
import AlertModal from "../../../components/Tmail/components/Modals/AlertModal";
import SignatureListModal from "./components/SignatureListModal";
import Swal from "sweetalert2";

const BASE_URL = process.env.REACT_APP_BASEURL;

const TmailMessageBoxV2 = (props) => {
    // const signatures = useSelector((state) => state.tmail.signatures);
    const { itemId, uuid, app_id, unique_id } = useParams();

    const { search } = useLocation();
    const commentId = new URLSearchParams(search).get("commentId");
    const authId = new URLSearchParams(search).get("authId");
    const type = new URLSearchParams(search).get("type");

    const [bigData, setBigData] = useState(null);
    const [userData, setUserData] = useState(null);
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [messageHtml, setMessageHtml] = useState("");
    const [signatureOption, setSignatureOption] = useState("");
    const [appId, setAppId] = useState("");
    const [options, setOptions] = useState([]);
    const [defaultFrom, setDefaultFrom] = useState([]);
    const [signatures, setSignatures] = useState([]);
    const [itemid_s, setItemId] = useState(null);
    const [selectedFrom, setSelectedFrom] = useState(null);
    const [preLoadItem, setPreLoadItem] = useState(null);
    const [response, setResponse] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [openSignature, setOpenSignature] = useState(false);
    const [toEmail, setToEmail] = useState([]);
    const [ccEmail, setCCEmail] = useState([]);
    const [toEmailDefault, setToEmailDefault] = useState([]);
    const [ccEmailDefault, setCCEmailDefault] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({
        name: userData ? userData.name : "",
        fromEmail: userData ? userData.email : "",
    });

    const [from, setFrom] = useState("");
    const closeModal = () => setOpenModal(false);
    const closeSignModal = () => {
        setSignatureOption("none");
        setOpenSignature(false);
    };

    const openFirstModal = () => {
        setOpenSignature(true);
    };

    useEffect(() => {
        const url = `${BASE_URL}/tmail/composer/config`;
        const payload = {
            uuid,
            item_id: itemId,
            podio_user_id: authId,
            app_id,
            app_item_id: unique_id,
        };
        setLoading(true);
        Axios.post(url, payload)
            .then((res) => {
                setLoading(false);
                if (res.data.app_check === false) {
                    setLoading(false);
                    setOpenModal(true);
                }
                const response = res.data;
                const authToken = response.data.user.token;
                const theItemID = response.response.item_id;
                setPreLoadItem(response.response.item_id);
                setBigData(response);
                setAppId(response.data.app_id);
                localStorage.removeItem("chosen_token");
                localStorage.removeItem("team_member_uuid");
                localStorage.setItem("chosen_token", authToken);
                localStorage.setItem("chosen_token_v2", authToken);
                const config = {
                    headers: {
                        Authorization: "Bearer " + authToken,
                    },
                };

                setSignatures(response.data.signatures);
                setDefaultFrom(response.data.default_emails);
                if (response.data.default_emails.length === 0) {
                    const user = [
                        {
                            name: response.data.user.name,
                            email: response.data.user.email,
                        },
                    ];
                    setDefaultFrom(user);
                }

                setUserData(response.data.user);

                if (typeof itemId !== "undefined") {
                    const url = `${BASE_URL}/sync/podio/get/item/${itemId}`;
                    setLoading(true);
                    Axios.get(url, config)
                        .then((res) => {
                            const response = res.data;
                            let sub = res.data.response.title;
                            if (type === "forward") {
                                sub = `FWD: ${res.data.response.title}`;
                            }
                            if (type === "reply") {
                                sub = `RE: ${res.data.response.title}`;
                            }
                            setSubject(sub);
                            const savedEmails = res.data.data.saved_emails;

                            const optionDatas =
                                savedEmails.length > 0
                                    ? savedEmails.map((saved) => {
                                          return {
                                              label: `${saved}`,
                                              value: saved,
                                          };
                                      })
                                    : [];
                            setOptions(optionDatas);
                            setLoading(false);
                            setResponse(response);
                        })
                        .catch((err) => {
                            setLoading(false);
                        });
                } else {
                    const url = `${BASE_URL}/sync/podio/get/item/${app_id}/${unique_id}`;
                    setLoading(true);
                    Axios.get(url, config)
                        .then((res) => {
                            let sub = res.data.response.title;
                            setItemId(res.data.response.item_id);
                            if (type === "forward") {
                                sub = `FWD: ${res.data.response.title}`;
                            }
                            if (type === "reply") {
                                sub = `RE: ${res.data.response.title}`;
                            }
                            setSubject(sub);
                            // setAppId(res.data.app_id)
                            setLoading(false);
                            if (!res.data.app_check) {
                                setOpenModal(true);
                            }
                            const response = res.data;
                            const savedEmails = res.data.data.saved_emails;

                            const optionDatas =
                                savedEmails.length > 0
                                    ? savedEmails.map((saved) => {
                                          return {
                                              label: `${saved}`,
                                              value: saved,
                                          };
                                      })
                                    : [];
                            setOptions(optionDatas);
                            setResponse(response);
                        })
                        .catch((err) => {
                            setLoading(false);
                        });
                }

                if (commentId !== null) {
                    const url = `${BASE_URL}/sync/podio/get-tmail-comment/${commentId}`;
                    Axios.get(url, config)
                        .then((res) => {
                            const response = res.data.response;
                            let sub = response.subject;

                            const ccEmailData = JSON.parse(response.cc);
                            const toEmailData = JSON.parse(response.to);
                            if (ccEmailData.length > 0) {
                                const selectCC = ccEmailData.map((data) => {
                                    return {
                                        value: data,
                                        label: `${data}`,
                                    };
                                });
                                setCCEmail(selectCC);
                                setCCEmailDefault(selectCC);
                            }

                            const selectTo = toEmailData.map((data) => {
                                return {
                                    value: data,
                                    label: `${data}<${data}>`,
                                };
                            });
                            setToEmail(selectTo);
                            setToEmailDefault(selectTo);

                            const date = dayjs(response.created_at).format(
                                "ddd, D MMM YYYY HH:mm:ss"
                            );

                            let originalMessage = `<br><br><br><br>`;
                            originalMessage += `<p>------ Original message ------</p>`;
                            originalMessage += `From: "${response.from_name}" (${response.from_email})`;
                            originalMessage += `<br>`;
                            originalMessage += `To: ${JSON.parse(response.to)}`;
                            originalMessage += `<br>`;
                            originalMessage += `CC: ${JSON.parse(response.cc)}`;
                            originalMessage += `<br>`;
                            originalMessage += `Date: ${date}`;
                            originalMessage += `<br>`;
                            originalMessage += `Subject: ${response.subject}`;
                            originalMessage += `${response.message}`;
                            originalMessage += `<br>`;

                            if (type === "forward") {
                                originalMessage = response.message;
                                sub = `FWD: ${response.subject}`;
                            }
                            if (type === "reply") {
                                sub = `RE: ${response.subject}`;
                            }
                            setSubject(sub);
                            // setMessage(originalMessage);

                            setLoading(false);
                        })
                        .catch((err) => {
                            setLoading(false);
                        });
                }
            })
            .catch((err) => {
                setLoading(false);
                // setOpenModal(true);
            });
    }, []);

    const fromEmails =
        defaultFrom.length > 0
            ? defaultFrom.map((from) => (
                  <option key={from.email} value={from.email}>
                      {from.email}
                  </option>
              ))
            : [];

    const { name, fromEmail } = data;

    const handleFromChange = (e) => {
        const val = e.target.value;
        setFrom(val);
        const selected = defaultFrom.find((where) => where.email === val);
        setSelectedFrom(selected.name);
        setData({
            name: selected.name,
            fromEmail: selected.email,
        });
    };

    const subjectHandleChange = (e) => {
        setSubject(e.target.value);
    };

    const handleSignatureChange = (val) => {
        setSignatures(val);
    };

    const toChangehandler = (val) => {
        extractEmailValues(val);
        setToEmail(val);
    };
    const ccChangehandler = (val) => {
        setCCEmail(val);
    };

    const messageChangeHandler = (value) => {
        setMessage(value);
    };

    const handleFileChange = (e) => {
        const oldArr = [...attachments];
        const newArr = Array.from(e.target.files);
        const joinedArr = [...oldArr, ...newArr];
        setAttachments(joinedArr);
    };

    const addAttachment = (file) => {
        setAttachments((prevArr) => [...prevArr, ...[file]]);
    };

    const removeAttachment = (file) => {
        const files = attachments.filter((attach) => attach.name !== file.name);
        setAttachments(files);
    };

    const extractEmailValues = (emails) => {
        let list = [];
        emails.forEach((mail) => {
            list.push(mail.value);
        });
        return list;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (
            name === "" ||
            fromEmail === "" ||
            toEmail.length === 0 ||
            message === ""
        ) {
            setLoading(false);
            toast.notify("Please fill required data", { type: "info" });
            return;
        }
        let originalMessage = `${messageHtml}`;
        originalMessage += `<br><br><br><br><br>`;
        originalMessage += `<small><i>The Following Data is Used for Identification Purposes. DO NOT DELETE.</i></small>`;
        originalMessage += `<br>`;

        if (response.data.item_id != null) {
            originalMessage += `<small><i>Record: ${response.data?.item_id}</i></small>`;
            originalMessage += `<br>`;
        }
        if (response.data.applicant != null) {
            originalMessage += `<small><i>Applicant: ${response.data?.applicant}</i></small>`;
            originalMessage += `<br>`;
        }

        if (response.data.full_email != null) {
            originalMessage += `<small><i>Email: ${response.data?.full_email}</i></small>`;
            originalMessage += `<br>`;
        }
        if (response.data.application_number != null) {
            originalMessage += `<small><i>Applicant Number: ${response.data?.application_number}</i></small>`;
            originalMessage += `<br>`;
        }
        const formData = new FormData();
        for (let i = 0; i < attachments.length; i++) {
            formData.append(`attachments[]`, attachments[i]);
        }
        var id_ = typeof itemId != "undefined" ? itemId : itemid_s;
        formData.append(`itemId`, id_);
        formData.append(`email`, fromEmail);
        formData.append(`name`, name);
        formData.append(`toEmail`, JSON.stringify(toEmail));
        formData.append(`ccEmail`, JSON.stringify(ccEmail));
        formData.append(`subject`, subject);
        formData.append(`message`, originalMessage);
        formData.append(`commentId`, commentId != null ? commentId : "");
        formData.append(`type`, type != null ? type : "");
        try {
            const config = {
                headers: {
                    Authorization: "Bearer " + bigData.data.user.token,
                },
            };
            await Axios.post(
                `${BASE_URL}/sync/podio/tmail-send`,
                formData,
                config
            );
            setLoading(false);
            Swal.fire({
                title: "Success",
                // imageUrl:
                //     "https://t4.ftcdn.net/jpg/05/10/52/31/360_F_510523138_0c1lsboUsa9qvOSxdaOrQIYm2eAhjiGw.jpg",
                icon: "success",
                imageWidth: "75px",
                text: "Message Sent Successfully",
                buttonsStyling: "false",
                confirmButtonText: "Continue",
                confirmButtonColor: "#FCAF3B",
            }).then(() => {
                setTimeout(() => {
                    window.close();
                }, 3000);
            });
            // setAttachments([]);
            // localStorage.removeItem("chosen_token");
        } catch (error) {
            setLoading(false);
            toast.notify("Error Sending Mail", { type: "error" });
        }
    };

    const changeSignBox = (e) => {
        const val = e.target.value;
        if (val === "configure_signature") {
            setOpenSignature(true);
            setSignatureOption(val);
            return;
        }
        signatures.forEach((sign) => {
            if (sign.id == val) {
                let originalMessage = message;
                originalMessage += `<br><br><br><br>`;
                originalMessage += `<p>${sign.content}</p>`;
                setMessage(originalMessage);
                // messageChangeHandler(originalMessage)
            }
        });
        setSignatureOption(val);
    };
    const signatureOptions =
        signatures.length > 0
            ? signatures.map((sign) => (
                  <option key={sign.id} value={sign.id}>
                      {sign.name}
                  </option>
              ))
            : null;
    // Todo: Signature feature
    const msg =
        "This app isn't connected to your Tmail account. Kindly login and connect this app.";
    const redirect = "Redirect to Dashboard";
    const redirectUrl = "/dashboard/tmail/apps";
    return (
        <div className="auth">
            <AlertModal
                message={msg}
                openModal={openModal}
                handleClose={closeModal}
                url={redirectUrl}
                redirect={redirect}
            />
            <SignatureListModal
                openModal={openSignature}
                signatures={signatures}
                handleClose={closeSignModal}
                appId={appId}
                handleSignatureChange={handleSignatureChange}
                openFirstModal={openFirstModal}
            />

            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="">
                        <div className="custom__container__80 mt-4">
                            <div className="text-right"></div>
                            <div className="box-message">
                                <h3>Draft Message</h3>
                                {loading ? (
                                    <CircularProgress color="info" size={40} />
                                ) : (
                                    <form
                                        onSubmit={handleSubmit}
                                        className="mt-5"
                                        encType="multipart/form-data"
                                    >
                                        <div className="form-row">
                                            <div className="form-group col-md-2">
                                                <label
                                                    style={{
                                                        fontWeight: "normal",
                                                        fontSize: "18px",
                                                        marginTop: "5px",
                                                    }}
                                                >
                                                    From <span className="text-danger">*</span>
                                                </label>
                                            </div>
                                            <div className="form-group col-md-10">
                                                <div className="form-row">
                                                    <div className="col-md-6">
                                                        <input
                                                            className="form-control"
                                                            name="name"
                                                            value={selectedFrom}
                                                            required
                                                            type="text"
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <select
                                                            className="form-control"
                                                            name="fromEmail"
                                                            onChange={
                                                                handleFromChange
                                                            }
                                                            required
                                                        >
                                                            <option>
                                                                Select Email
                                                            </option>
                                                            {fromEmails}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="form-group col-md-2">
                                                <label
                                                    style={{
                                                        fontWeight: "normal",
                                                        fontSize: "18px",
                                                        marginTop: "5px",
                                                    }}
                                                >
                                                    To <span className="text-danger">*</span>
                                                </label>
                                            </div>
                                            <div className="form-group col-md-10">
                                                <EmailContact
                                                    options={options}
                                                    handleChange={
                                                        toChangehandler
                                                    }
                                                    default={toEmailDefault}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="form-group col-md-2">
                                                <label
                                                    style={{
                                                        fontWeight: "normal",
                                                        fontSize: "18px",
                                                        marginTop: "5px",
                                                    }}
                                                >
                                                    CC
                                                </label>
                                            </div>
                                            <div className="form-group col-md-10">
                                                <EmailContact
                                                    options={options}
                                                    handleChange={
                                                        ccChangehandler
                                                    }
                                                    default={ccEmailDefault}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="form-group col-md-2">
                                                <label
                                                    style={{
                                                        fontWeight: "normal",
                                                        fontSize: "18px",
                                                        marginTop: "5px",
                                                    }}
                                                >
                                                    Subject
                                                </label>
                                            </div>
                                            <div className="form-group col-md-10">
                                                <input
                                                    className="form-control"
                                                    name="subject"
                                                    value={subject}
                                                    required
                                                    type="text"
                                                    onChange={
                                                        subjectHandleChange
                                                    }
                                                />
                                            </div>
                                        </div>

                                        <div className="form-row">
                                            <div className="form-group col-md-2">
                                                <label
                                                    style={{
                                                        fontWeight: "normal",
                                                        fontSize: "18px",
                                                        marginTop: "5px",
                                                    }}
                                                >
                                                    Attachments
                                                </label>
                                            </div>
                                            <div className="form-group col-md-9">
                                                <input
                                                    type="file"
                                                    name="attachments"
                                                    className="form-control-file"
                                                    multiple
                                                    onChange={handleFileChange}
                                                />
                                            </div>
                                        </div>
                                        {attachments.length > 0 ? (
                                            <div className="mb-4">
                                                {attachments.map((file) => {
                                                    return (
                                                        <ul
                                                            className="list-group"
                                                            key={file.name}
                                                        >
                                                            <li className="list-group-item text-muted">
                                                                {file.name}
                                                                <i
                                                                    className="fas fa-window-close text-danger float-right ml-2"
                                                                    onClick={() =>
                                                                        removeAttachment(
                                                                            file
                                                                        )
                                                                    }
                                                                ></i>
                                                            </li>
                                                        </ul>
                                                    );
                                                })}
                                            </div>
                                        ) : null}

                                        <div className="form-row">
                                            <div className="form-group col-md-12">
                                                <TextEditor
                                                    setMessageHtml={
                                                        setMessageHtml
                                                    }
                                                    change={
                                                        messageChangeHandler
                                                    }
                                                    msg={message}
                                                    addAttachment={
                                                        addAttachment
                                                    }
                                                />
                                            </div>
                                        </div>

                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            size="large"
                                            type="submit"
                                        >
                                            Send
                                        </Button>
                                        <div className="form-row mt-4">
                                            <div className="form-group col-md-3">
                                                <label
                                                    htmlFor="signature"
                                                    style={{
                                                        fontWeight: "normal",
                                                        fontSize: "18px",
                                                        marginTop: "5px",
                                                    }}
                                                >
                                                    Signature
                                                </label>
                                            </div>
                                            <div className="form-group col-md-4"></div>
                                            <div className="form-group col-md-4">
                                                <select
                                                    onChange={changeSignBox}
                                                    name="signature"
                                                    value={signatureOption}
                                                    className="form-control"
                                                >
                                                    <option value="none">
                                                        None
                                                    </option>
                                                    {signatureOptions}
                                                    <option value="configure_signature">
                                                        Configure Signatures
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default TmailMessageBoxV2;
